import { Calendar } from '@fullcalendar/core';
import Fullcalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
// import listPlugin from "@fullcalendar/list";

// require("@fullcalendar/core/main.min.css");
// require("@fullcalendar/daygrid/main.min.css");
// require("@fullcalendar/timegrid/main.min.css");



const options = {
    calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, Calendar],
        initialView: "dayGridMonth",
        displayEventTime: "false",
    },
    calendarPlugins: [dayGridPlugin, interactionPlugin],
}

export default {
    install(app) {
        app.use(Fullcalendar, options);
    }
};